module.exports = __webpack_public_path__ + "static/githzerai-MGZN_DRGN_378-8949a4475445205286d4e21848da4814.jpg";